import { Resource } from "../resource";


export class UserComment extends Resource{
    text: string
    type: string
}